import { createVNode as a, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/WowjoyFilledStandard.js";
import i from "../components/PfIcon.js";
const o = (r, t) => {
  const e = {
    ...r,
    ...t.attrs
  };
  return a(i, d(e, {
    icon: l
  }), null);
};
o.displayName = "WowjoyFilledStandard";
o.inheritAttrs = !1;
export {
  o as default
};
